import React from 'react';
import RackSelector from './components/RackSelector/RackSelector';
import InfoWindow from './components/InfoWindow/InfoWindow';
import StepEnum from './Enums/StepEnum';
import { setCookieData, updateOnFitStatusChange } from './Hooks/hooks';
import StatusEnum from './Enums/StatusEnum';
import { getWindowData } from '../FitAssistantShared/GetWindowData';
import { onRackSelectorClose } from './Utils/Tracking';

const Modal = ({
  isVisible,
  setVisibility,
  translations,
  filters,
  step,
  handleStepSelect,
  handleReset,
  categoryLink,
  handleProductSelect,
  handleNonThuleRack,
  selectedProduct,
  imageUrl,
  imageAlt,
}) => {
  const showThirdPartyRoofRackSecondaryButton =
    !getWindowData()?._buyersGuide && getWindowData()?.SitecoreSiteName === 'Thule';

  const closeModal = () => {
    setVisibility(false);
    onRackSelectorClose(selectedProduct ?? '');
  };

  return (
    <>
      <div className={`fit-guide-modal on-top ${isVisible ? 'wrapper-visible' : ''}`}>
        <section className="modal-content-section d-inline-block">
          <div className="fit-guide-modal-header">
            <div>
              {step === StepEnum.ThirdParty && (
                <button className="btn hide-fit-guide-modal" onClick={() => handleReset()}>
                  <span>
                    <i className="le-icon-arrow"></i>
                  </span>
                  <span className="sr-only">Back</span>
                </button>
              )}
            </div>

            <button className="btn hide-fit-guide-modal" onClick={closeModal}>
              <span>
                <i className="le-icon-x"></i>
              </span>
              <span className="sr-only">Close fit guide</span>
            </button>
          </div>
          {step === StepEnum.RackSelect && (
            <RackSelector
              translations={translations}
              filters={filters}
              handleProductSelect={handleProductSelect}
              selectionText={selectedProduct}
              handleNonThuleRack={handleNonThuleRack}
              defaultButtonCallback={() => {
                handleStepSelect(StepEnum.ThirdParty);
                updateOnFitStatusChange(StatusEnum.Unconfirmed);
                handleNonThuleRack(StatusEnum.Unconfirmed);
                setCookieData({ step: StepEnum.ThirdParty, fitStatus: StatusEnum.Unconfirmed });
                onRackSelectorClose('I do not have a roof rack');
              }}
              defaultButtonText={translations.AnotherRoofRack}
              secondaryButtonCallback={() => {
                onRackSelectorClose('I need a roof rack');
                window.location.href = categoryLink;
              }}
              secondaryButtonText={translations.NoRoofRackHeader}
            />
          )}
          {step === StepEnum.ThirdParty && (
            <InfoWindow
              imageUrl={imageUrl}
              imageAlt={imageAlt}
              header={translations.ThirdPartyHeader}
              body={translations.ThirdPartyText}
              defaultButtonText={translations.IUnderstand}
              secondaryButtonText={showThirdPartyRoofRackSecondaryButton ? translations.ShopThuleRacks : null}
              defaultButtonCallback={() => {
                setVisibility(false);
              }}
              secondaryButtonCallback={() => {
                window.location.href = categoryLink;
              }}
            />
          )}
        </section>
      </div>
      <div className={`fit-guide-modal-left-slide-in-backdrop ${isVisible ? 'active' : ''}`} onClick={closeModal}></div>
    </>
  );
};

export default Modal;
